export const ADD_PERSONAL_INFORMATION_STARTED =
  'ADD_PERSONAL_INFORMATION_STARTED';
export const ADD_PERSONAL_INFORMATION_SUCCESS =
  'ADD_PERSONAL_INFORMATION_SUCCESS';
export const ADD_PERSONAL_INFORMATION_ENDED = 'ADD_PERSONAL_INFORMATION_ENDED';
export const ADD_PERSONAL_INFORMATION_ERROR = 'ADD_PERSONAL_INFORMATION_ERROR';
